import { View } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';

import { tableStyles } from '../Table/tableStyles.ts';
import { Text } from '../Text/Text.tsx';
import { sharedStyles } from '../sharedStyles.ts';

type Props = {
  style?: Style;
  children: string;
};

export const Th = ({ style = {}, children }: Props) => (
  <View style={[tableStyles.cell, sharedStyles.fullWidth, sharedStyles.verticalCenter, style]}>
    <Text variant="th">{children}</Text>
  </View>
);
